import ReactCookie from 'react-cookie'
import * as actionTypes from '../actions/actionTypes'
import * as jwtUtils from '../utils/jwtUtils'

const initialState = ReactCookie.load('AUTH') || {
  token: null,
  username: null,
  isStaff: null,
  isAuthenticated: false,
  isAuthenticating: false
}

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOGIN_LOADING:
      return Object.assign({}, state, {
        isAuthenticating: true
      })
    case actionTypes.LOGIN_SUCCESS:
      let jwtPayload = jwtUtils.parseJwt(action.payload.token)
      let newState = Object.assign({}, state, {
        token: action.payload.token,
        username: jwtPayload.username,
        isStaff: jwtPayload.is_staff || false,
        isAuthenticated: true,
        isAuthenticating: false
      })
      ReactCookie.save('AUTH', newState)
      return newState
    case actionTypes.LOGIN_ERROR:
      return Object.assign({}, state, {
        token: null,
        username: null,
        isStaff: null,
        isAuthenticated: false,
        isAuthenticating: false
      })
    case actionTypes.LOGOUT:
      ReactCookie.remove('AUTH')
      return Object.assign({}, state, {
        token: null,
        username: null,
        isStaff: null,
        isAuthenticated: false,
        isAuthenticating: false
      })
    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/authReducers.js
 **/